import React from 'react';
import { shape, arrayOf, string } from 'prop-types';
import { Typography } from '@andes/typography';
import { MoneyAmount } from '@andes/money-amount';

const DEFAULT_MAP_CONTENT = {
  values: [],
};

const CbtTaxesSummary = ({ namespace, map_content = DEFAULT_MAP_CONTENT }) => {
  if (!map_content || !map_content.values) {
    return null;
  }

  return (
    <div className={`${namespace}__map-content`}>
      {map_content.values.map(value => (
        <>
          <Typography component="span">{value.description}</Typography>
          <Typography>
            {value.value && (
              <MoneyAmount
                value={{ fraction: value.value.fraction_value, cents: value.value.cents }}
                centsType="superscript"
                symbol={value.value.currency_symbol}
                size={16}
              />
            )}
          </Typography>
        </>
      ))}
    </div>
  );
};

CbtTaxesSummary.propTypes = {
  namespace: string.isRequired,
  map_content: shape({
    values: arrayOf(
      shape({
        description: string,
        value: shape({
          fraction_value: string,
          cents: string,
          currency_symbol: string,
        }),
      }),
    ),
  }),
};

export default CbtTaxesSummary;
